import billingModule from '../../billing.module';
import template from './billingIconPayment.component.html';
import style from './billingIconPayment.component.css';

export default billingModule.component('billingIconPayment', {
    template,
    style,
    bindings: {
        fill: '<'
    },
    controller(billingColorConstants) {
        var vm = this;

        vm.$onInit = () => {
            vm.pathStyle = {
                fill: billingColorConstants[vm.fill] || vm.fill
            };
        };
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-icon-payment/billingIconPayment.component.js